import extend from 'extend'
import BaseTheme from './base'

const TOOLBAR_CONFIG = [
  [{ header: ['1', '2', '3', false] }],
  ['bold', 'italic', 'underline', 'link'],
  [{ list: 'ordered' }, { list: 'bullet' }],
  ['clean'],
]

class SnowTheme extends BaseTheme {
  constructor(quill, options) {
    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG
    }
    super(quill, options)
    this.quill.container.classList.add('ql-snow')
  }

  extendToolbar(toolbar) {
    toolbar.container.classList.add('ql-snow')
  }
}

SnowTheme.DEFAULTS = extend(true, {}, BaseTheme.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function(value) {
          if (value) {
            let range = this.quill.getSelection()
            if (range == null || range.length === 0) return
            let preview = this.quill.getText(range)
            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
              preview = 'mailto:' + preview
            }
            let tooltip = this.quill.theme.tooltip
            tooltip.edit('link', preview)
          } else {
            this.quill.format('link', false)
          }
        },
      },
    },
  },
})

export default SnowTheme
